import { match } from 'ts-pattern'
import * as v from 'valibot'
import { I18nStringPairsSchema } from 'src/i18n/localizedContent'
import {
  CampaignMediaType,
  CollectionCardType,
} from 'src/services/apollo/generated/graphql'

const CollectionCardNameSchema = v.strictObject({
  name: I18nStringPairsSchema,
})
const CollectionCardMediaItemSchema = v.strictObject({
  media: v.string(),
  mediaId: v.optional(v.string()),
  mediaType: v.union([
    v.literal(CampaignMediaType.Image),
    v.literal(CampaignMediaType.Video),
    v.literal(CampaignMediaType.VideoHls),
    v.literal(CampaignMediaType.VideoStream),
  ]),
})

/** Basic Card - Only one media */
export const CollectionCardDataStaticSchema = v.strictObject({
  ...CollectionCardNameSchema.entries,
  ...CollectionCardMediaItemSchema.entries,
})
/** Live Card - Basic Card with extra "live" media */
export const CollectionCardDataLiveSchema = v.strictObject({
  ...CollectionCardNameSchema.entries,
  ...CollectionCardMediaItemSchema.entries,

  live: v.strictObject({
    ...CollectionCardMediaItemSchema.entries,
  }),
})
/** Audio Card - Basic Card with extra features with is currently not yet planned */
const CollectionCardDataAudioSchema = v.strictObject({
  ...CollectionCardNameSchema.entries,
  ...CollectionCardMediaItemSchema.entries,

  audio: v.strictObject({
    description: v.optional(v.string()),
    // TO be implemented
  }),
})

export function getCollectionCardDataSchema(type?: CollectionCardType) {
  return match(type)
    .with(CollectionCardType.Static, () => CollectionCardDataStaticSchema)
    .with(CollectionCardType.Live, () => CollectionCardDataLiveSchema)
    .with(CollectionCardType.Audio, () => CollectionCardDataAudioSchema)
    .otherwise(() => CollectionCardDataStaticSchema)
}

export const CollectionCardSetDataSchema = v.strictObject({
  name: I18nStringPairsSchema,
})
export type CollectionCardSetDataType = v.InferInput<
  typeof CollectionCardSetDataSchema
>
export type CollectionCardDataMediaType = v.InferInput<
  typeof CollectionCardMediaItemSchema
>
